export default __webpack_public_path__ + "static/media/turvaohje.a959c4b6.jpeg";